import React from "react";
import { Link } from "react-router-dom";
import MarketingLayout from "@/components/marketing/MarketingLayout";
import Seo from "@/components/Seo";
import { ArrowRight, FileText, BarChart3 } from "lucide-react";

export default function CaseStudies() {
  return (
    <MarketingLayout>
      <Seo
        title="Case Studies · Yosi Media Studio"
        description="Real growth stories from local businesses in Alabama and Tennessee. Every case study is measured with real analytics — no invented numbers."
      />
      <section className="max-w-6xl mx-auto px-6 sm:px-8 py-20" data-testid="case-studies-page">
        <div className="text-xs uppercase tracking-widest font-bold mb-3" style={{ color: "#2B87F5" }}>Case Studies</div>
        <h1 className="font-display font-black text-4xl sm:text-5xl leading-tight text-white mb-4">
          Real Growth. <span style={{ color: "#2B87F5" }}>Real Data.</span>
        </h1>
        <p className="max-w-2xl text-slate-400 leading-relaxed mb-14">
          Every case study on this page uses verified metrics from Google Analytics, Search Console, Google Business Profile, and call tracking.
          We show the challenge, the strategy, and the measurable outcome — never invented numbers.
        </p>

        <div className="rounded-2xl border border-slate-800 bg-slate-900/40 p-10 text-center" data-testid="case-studies-empty">
          <FileText className="w-10 h-10 mx-auto text-slate-500 mb-4" />
          <h2 className="font-display text-2xl font-bold text-slate-100 mb-2">Case studies coming soon</h2>
          <p className="text-slate-400 max-w-xl mx-auto mb-6">
            We're documenting current client projects with verified analytics. The first case studies will publish
            once we have enough measurable data to share responsibly.
          </p>
          <Link to="/contact?audit=1" data-testid="case-cta"
            className="btn-scale inline-flex items-center gap-2 h-11 px-6 rounded-full text-white font-bold text-sm shadow-[0_14px_36px_rgba(43,135,245,0.4)]"
            style={{ background: "#2B87F5" }}>
            Get a Free Growth Audit <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { t: "Verified Analytics", d: "Google Analytics 4 + Search Console feed every case study." },
            { t: "Call Tracking", d: "Every inbound call captured, attributed, and measured." },
            { t: "Honest Reporting", d: "If a strategy didn't move the needle, we say so." },
          ].map((x) => (
            <div key={x.t} className="rounded-xl border border-slate-800 bg-slate-900/30 p-6">
              <BarChart3 className="w-5 h-5 mb-3" style={{ color: "#2B87F5" }} />
              <h3 className="font-semibold text-slate-100 mb-1">{x.t}</h3>
              <p className="text-sm text-slate-400 leading-relaxed">{x.d}</p>
            </div>
          ))}
        </div>
      </section>
    </MarketingLayout>
  );
}
